import {
	Component,
	input,
	output,
	computed,
	ChangeDetectionStrategy,
} from '@angular/core'
import { BaseAction } from '../../models/base-action.model'
import { getFuzzyHighlightSegments } from '../../utils/fuzzy-highlight.util'

@Component({
	selector: 'lowgile-result-item',
	templateUrl: './result-item.component.html',
	styleUrls: ['./result-item.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ResultItemComponent {
	action = input.required<BaseAction>()
	isActive = input<boolean>(false)
	query = input<string>('')
	select = output<BaseAction>()

	highlightedLabel = computed(() =>
		getFuzzyHighlightSegments(this.query(), this.action().label),
	)

	onSelect(): void {
		this.select.emit(this.action())
	}

	onKeyDown(event: KeyboardEvent): void {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault()
			this.onSelect()
		}
	}
}
